// extracted by mini-css-extract-plugin
export default {"select":"Select_select__aeuTF","title":"Select_title__D4sfj","isOpened":"Select_isOpened__lHoUJ"};